import { useEffect, useMemo, useState } from "react";

// Computes the first Monday of October for a given year
const getCustomerServiceWeekStart = (year) => {
  // Month is 0-indexed: 9 => October
  const firstOfOctober = new Date(year, 9, 1);
  const dayOfWeek = firstOfOctober.getDay(); // 0-6 (Sun-Sat)
  const daysUntilMonday = (1 - dayOfWeek + 7) % 7; // 1 is Monday
  return new Date(year, 9, 1 + daysUntilMonday);
};

export const useCustomerServiceWeek = () => {
  const [show, setShow] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const now = new Date();
  const year = now.getFullYear();

  const weekStart = useMemo(() => getCustomerServiceWeekStart(year), [year]);
  const weekEnd = useMemo(() => {
    const end = new Date(weekStart);
    end.setDate(end.getDate() + 7); // Monday of next week
    end.setHours(23, 59, 59, 999);
    return end;
  }, [weekStart]);

  const isWithinWeek = now >= weekStart && now <= weekEnd;
  const storageKey = `rc_csw_dismissed_${year}`;

  useEffect(() => {
    if (!isWithinWeek) return;
    try {
      const dismissed = localStorage.getItem(storageKey);
      if (dismissed !== "true") {
        setShow(true);
      }
    } catch {
      setShow(true);
    }
  }, [isWithinWeek, storageKey]);

  const close = (persistPreference) => {
    if (persistPreference) {
      try {
        localStorage.setItem(storageKey, "true");
      } catch {}
    }
    setShow(false);
  };

  return {
    show,
    setShow,
    dontShowAgain,
    setDontShowAgain,
    weekStart,
    weekEnd,
    isWithinWeek,
    close,
  };
};

export default useCustomerServiceWeek;
